<a *ngIf="banner && banner.target_url && banner.img_url?.length > 0"
   [href]="banner.target_url" target="_blank" class="promo-banner d-block d-md-none">
  <img [src]="banner.img_url" alt="fan.at Promotion Banner">
</a>
<a *ngIf="banner && banner.target_url && banner.img_url_desktop?.length > 0"
   [href]="banner.target_url" target="_blank" class="promo-banner d-none d-md-block">
  <img [src]="banner.img_url_desktop" alt="fan.at Promotion Banner">
</a>
<div
  *ngIf="banner && !banner.target_url && banner.img_url?.length > 0"
  class="promo-banner"
  (click)="onBannerClick()"
>
  <img [src]="banner.img_url" alt="fan.at Promotion Banner">
</div>